import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { HomepageEventBanner } from '../../core/models/homepage-event-banner.model';
import { CxIconComponent } from '../../shared/icon/cx-icon.component';
import { HomepageEventBannerComponent } from '../../shared/homepage-event-banner/homepage-event-banner.component';

declare var $: any;
@Component({
  selector: 'app-landing-page-main',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    CxIconComponent,
    HomepageEventBannerComponent,
  ],
  templateUrl: './landing-page-main.component.html',
  styleUrls: ['./landing-page-main.component.scss'],
})
export class LandingPageMainComponent implements OnInit, AfterViewInit {
  activeSlide = 0; // 0 = slider1, 1 = slider2
  slide1State: 'idle' | 'enter' | 'exit' = 'idle';

  homepageEventBanner: HomepageEventBanner | null = null;

  @ViewChild('heroVideo') heroVideo!: ElementRef<HTMLVideoElement>;
  @ViewChild('founderVideo') founderVideo!: ElementRef<HTMLVideoElement>;

  isVideoPlaying = false;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.homepageEventBanner =
      this.route.snapshot.data['homepageEventBanner'] ?? null;

    // Initial animation
    setTimeout(() => {
      this.slide1State = 'enter';
    }, 100);

    setInterval(() => {
      if (this.activeSlide === 0) {
        /* STEP 1: EXIT animation */
        this.slide1State = 'exit';

        /* STEP 2: move to slider 2 */
        setTimeout(() => {
          this.activeSlide = 1;
          this.slide1State = 'idle'; // reset
        }, 600);
      } else {
        /* STEP 3: reset BEFORE enter */
        this.activeSlide = 0;
        this.slide1State = 'idle';

        /* STEP 4: force reflow + enter */
        setTimeout(() => {
          this.slide1State = 'enter';
        }, 50);
      }
    }, 3500);
  }
  ngAfterViewInit() {
    if (this.heroVideo) {
      const video = this.heroVideo.nativeElement;
      video.muted = true;
      video.playsInline = true;
      video.autoplay = true;

      const playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise.catch(() => {
          // Retry after user interaction fallback
          document.addEventListener('click', () => video.play(), {
            once: true,
          });
        });
      }
    }
  }

  toggleVideo() {
    if (!this.founderVideo) return;
    const video = this.founderVideo.nativeElement;
    if (video.paused) {
      video.play();
      this.isVideoPlaying = true;
    } else {
      video.pause();
      this.isVideoPlaying = false;
    }
  }

  onVideoEnded() {
    this.isVideoPlaying = false;
  }
}
